import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const staircase = [
    { name: 'Curved Staircase', route: '/curved_stair' },
    { name: 'Straight Staircase', route: '/straight_stair' },
    { name: 'Floating Stair', route: '/floating_stair' },
  ];

  const lift = [
    { name: 'Pro Series', route: '/pro_series' },
    { name: 'Panoramic Series', route: '/panoramic_series' },
    { name: 'Mini Series', route: '/mini_series' },
    { name: 'Classies Series', route: '/classies_series' }
  ];

  const support = [
    { name: 'Projects', route: '#projects' },
    { name: 'Contact', route: '#contact' },
    { name: 'Service', route: '#service' },
  ];

  return (
    <footer className="bg-premium-dark text-white pt-12 sm:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 sm:gap-12 mb-12 sm:mb-16">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4 sm:mb-6">
             
              <div>
                <div className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight">StairLifté</div>
                <div className="text-xs text-gray-400 tracking-widest">LIFT & STAIRCASE</div>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
              Engineering vertical mobility excellence. Trusted by architects, developers, and building managers worldwide for premium lift and stair solutions.
            </p>
            <div className="flex items-center space-x-4">
              <button className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-premium-gold transition-colors" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin-in"></i>
              </button>
              <button className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-premium-gold transition-colors" aria-label="Facebook">
                <i className="fa-brands fa-facebook-f"></i>
              </button>
              <button className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-premium-gold transition-colors" aria-label="Instagram">
                <i className="fa-brands fa-instagram"></i>
              </button>
              <button className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-premium-gold transition-colors" aria-label="YouTube">
                <i className="fa-brands fa-youtube"></i>
              </button>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-6 text-premium-gold">Staircase</h4>
            <ul className="space-y-3">
              {staircase.map((item, index) => (
                <li key={index}>
                  <Link to={item.route} className="text-gray-400 hover:text-premium-gold transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-6 text-premium-gold">Lift</h4>
            <ul className="space-y-3">
              {lift.map((item, index) => (
                <li key={index}>
                  <Link to={item.route} className="text-gray-400 hover:text-premium-gold transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-lg mb-6 text-premium-gold">Support</h4>
            <ul className="space-y-3">
              {support.map((item, index) => (
                <li key={index}>
                  <a href={item.route} className="text-gray-400 hover:text-premium-gold transition-colors">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/*
        <div className="grid grid-cols-3 gap-8 py-8 border-t border-b border-white/10">
          <div className="text-center">
            <div className="text-3xl font-bold text-premium-gold mb-2">500+</div>
            <div className="text-gray-400 text-sm">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-premium-gold mb-2">30</div>
            <div className="text-gray-400 text-sm">Years of Excellence</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-premium-gold mb-2">50+</div>
            <div className="text-gray-400 text-sm">Countries Served</div>
          </div>
        </div>
        */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-6 sm:pt-8 gap-4 sm:gap-0">
          <div className="text-gray-400 text-xs sm:text-sm text-center sm:text-left">
            © 2026 Stairlifte All rights reserved.
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
            <span className="text-gray-400 hover:text-premium-gold transition-colors cursor-pointer">Privacy Policy</span>
            <span className="text-gray-400 hover:text-premium-gold transition-colors cursor-pointer">Terms of Service</span>
            <span className="text-gray-400 hover:text-premium-gold transition-colors cursor-pointer">Cookie Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
